import { useMemo } from 'react';

export const useNumericStepInput = ({
  value,
  onChange,
  step,
  allowNegative,
  decrementDisabled,
  incrementDisabled,
}) => {
  const handleDecrement = () => {
    if (!allowNegative && value - step < 0) return;
    onChange(parseFloat((value - step).toFixed(2)));
  };

  const handleIncrement = () => {
    onChange(parseFloat((value + step).toFixed(2)));
  };

  const dDisabled = useMemo(
    () => (decrementDisabled ? decrementDisabled(value) : false),
    [decrementDisabled, value],
  );

  const iDisabled = useMemo(
    () => (incrementDisabled ? incrementDisabled(value) : false),
    [incrementDisabled, value],
  );

  return {
    handleDecrement,
    handleIncrement,
    dDisabled,
    iDisabled,
  };
};
